import { render, staticRenderFns } from "./AboutAccordionItem.vue?vue&type=template&id=db3d2ee6&scoped=true&"
import script from "./AboutAccordionItem.vue?vue&type=script&lang=js&"
export * from "./AboutAccordionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db3d2ee6",
  null
  
)

export default component.exports